import React from 'react';

class ContextMenu extends React.Component {

    camelCase = (string) => {
        return string.split(" ")
            .map((x, i) => {
                if (i !== 0) {
                    return x.charAt(0).toUpperCase() + x.slice(1)
                } else {
                    return x
                }
            }).join("")
    }

    handleInfo = () => {
        if (this.props.info) {
            return this.props.info.map(x => `${x}`)
        }
    }

    render() {
        const style = { left: `${this.props.xPos}px`, top: `${this.props.yPos}px` }
        return (<div className="contextMenu" style={style}>
            {this.handleInfo()}
            {this.props.menuTemplate.map((x, i) => <div
                onClick={(event) => { event.preventDefault(); this.props[this.camelCase(x)](this.props.id); }}
                className="contextMenuLineItem" key={i}>{x}</div>)}
        </div>)
    }

}

export default ContextMenu